/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * BrandTemplateHandler
 * Manages alternate brand information in session storage
 * Handles checking, saving, and removing brand information based on window.Shopify.alternateBrand
 */
function BrandTemplateHandler() {
  this.storageKey = 'shopify_alternate_brand';
  this.brand = null;
  this.brandUrlParams = '';

  // Immediate initialization
  this.initialize();
}

/**
 * Initialize the handler and process brand information based on DOM readiness
 */
BrandTemplateHandler.prototype.initialize = function () {
  var self = this;
  if (window.Shopify && _typeof(window.Shopify) === 'object') {
    this.processBrandInfo();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      self.processBrandInfo();
    });
  }
};

/**
 * Process brand information based on availability
 */
BrandTemplateHandler.prototype.processBrandInfo = function () {
  try {
    this.cleanupReferrerData();
    var brandInfo = this.hasAlternateBrand();
    var hasBrand = brandInfo.hasBrand;
    var brand = brandInfo.brand;
    if (!hasBrand) {
      this.removeBrandFromSession();
      this.brand = null;
      return;
    }
    var alternateShopifyBrand = null;
    if (window.Shopify && window.Shopify.alternateBrand && window.Shopify.alternateBrand.brand) {
      alternateShopifyBrand = window.Shopify.alternateBrand.brand;
    }
    var hasStoredBrand = window.sessionStorage.getItem(this.storageKey);

    // Only update session if necessary
    if (alternateShopifyBrand && (alternateShopifyBrand !== brand || !hasStoredBrand)) {
      this.saveBrandToSession(alternateShopifyBrand);
    }
  } catch (error) {
    console.error('Error processing brand information:', error);
  }
};

/**
 * Clean up search data when navigating from a different page
 */
BrandTemplateHandler.prototype.cleanupReferrerData = function () {
  try {
    var referrerPathname = null;
    if (document.referrer) {
      referrerPathname = new URL(document.referrer).pathname;
    }
    var currentPathname = window.location.pathname;
    if (referrerPathname && referrerPathname !== currentPathname) {
      window.sessionStorage.removeItem('brand_search_performed');
    }
  } catch (error) {
    console.error('Error cleaning up referrer data:', error);
  }
};

/**
 * Check if alternate brand exists
 * @returns {Object} Object containing brand status and value
 */
BrandTemplateHandler.prototype.hasAlternateBrand = function () {
  try {
    var sessionBrand = sessionStorage.getItem(this.storageKey);
    var shopifyHasBrand = false;
    var shopifyBrandValue = null;
    if (window.Shopify && window.Shopify.alternateBrand) {
      shopifyHasBrand = window.Shopify.alternateBrand !== '';
      if (window.Shopify.alternateBrand.brand) {
        shopifyBrandValue = window.Shopify.alternateBrand.brand;
      }
    }
    var hasBrand = sessionBrand !== null || shopifyHasBrand;
    var brandValue = sessionBrand;
    if (!brandValue && shopifyBrandValue) {
      brandValue = shopifyBrandValue;
    }
    return {
      hasBrand: !!hasBrand,
      brand: brandValue
    };
  } catch (error) {
    console.error('Error checking for alternate brand:', error);
    return {
      hasBrand: false,
      brand: null
    };
  }
};

/**
 * Save brand information to session storage
 * @param {string} brandValue - The brand value to save
 * @returns {boolean} Whether saving was successful
 */
BrandTemplateHandler.prototype.saveBrandToSession = function (brandValue) {
  if (!brandValue) return false;
  try {
    sessionStorage.setItem(this.storageKey, brandValue);
    this.brand = brandValue;
    return true;
  } catch (error) {
    console.error('Failed to save brand to session storage:', error);
    return false;
  }
};

/**
 * Remove brand information from session storage
 * @returns {boolean} Whether removal was successful
 */
BrandTemplateHandler.prototype.removeBrandFromSession = function () {
  try {
    sessionStorage.removeItem(this.storageKey);
    return true;
  } catch (error) {
    console.error('Failed to remove brand from session storage:', error);
    return false;
  }
};

// Create a singleton instance when DOM is ready
var instance = null;
document.addEventListener('DOMContentLoaded', function () {
  if (!instance) {
    instance = new BrandTemplateHandler();
  }
});

/**
 * Get the singleton instance of BrandTemplateHandler
 * @returns {BrandTemplateHandler} The singleton instance
 */
function getInstance() {
  if (!instance) {
    instance = new BrandTemplateHandler();
  }
  return instance;
}

// Export for the module usage (if needed).
var brandTemplateHandlerExportObject = {
  getInstance: getInstance,
  BrandTemplateHandler: BrandTemplateHandler
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (brandTemplateHandlerExportObject)));
/******/ })()
;